// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2yjma","alert":"SettungsInbox_alert__2i0R4"};